import loginRequest from '../../services/login/login-requests';

export interface IAuthResult {
    success: boolean;
    redirectTo?: string;
}

export async function checkUserAuth(): Promise<IAuthResult> {
    return loginRequest.checkAuthorization();
}

const authUrl = '/login/auth';

const getAbsoluteUrl = (function(): (url: string) => string {
    let a: HTMLAnchorElement;

    return function(url: string): string {
        if (!a) {
            a = document.createElement('a');
        }
        a.href = url;
        return a.href;
    };
})();

export function handleAuthRedirect(auth: IAuthResult): boolean {
    if (auth.success) {
        if (auth.redirectTo && typeof window !== 'undefined') {
            const redirectTo = getAbsoluteUrl(auth.redirectTo).split('#')[0];
            const currentLocation = window.location.href.split('#')[0];
            if (redirectTo !== currentLocation) {
                window.location.replace(auth.redirectTo);
                return true;
            }
        }
    } else {
        // redirect to auth
        window.location.replace(authUrl);
        return true;
    }
    return false;
}
